/* eslint-disable spaced-comment */
/// <reference path="./dependency-shims.d.ts" />

import type React from 'react';
import { TextInput } from '@bingads-webui-react/text-input';
import type { ITextInputProps } from '@bingads-webui-react/text-input';
import { RadioGroup } from '@bingads-webui-react/radio';
import type { IRadioGroupProps } from '@bingads-webui-react/radio';
import { CheckboxGroup } from '@bingads-webui-react/checkbox';
import type { ICheckboxGroupProps } from '@bingads-webui-react/checkbox';
import { withValidation, ValidationGroup, withError } from '@bingads-webui-react/validation';
import type { ValidationProps } from '@bingads-webui-react/validation';
import { CheckedAdapter } from './src/checked-adapter';

export type { ICheckedAdapterProps } from './src/checked-adapter';

export interface IValidatedInputProps extends Omit<ITextInputProps, 'onChange' | 'value'> {
  onChange?: ITextInputProps['onChange'];
  validationProps: ValidationProps;
}

export type IValidatedRadioGroupProps<TItem = unknown> = Omit<
  IRadioGroupProps,
  'checked' | 'getItemId' | 'getItemValue' | 'items' | 'onChange' | 'renderItem'
> & {
  getItemId?: (item: TItem, index: number) => React.Key;
  getItemValue?: ((item: TItem, index: number) => string | number) | null;
  items: TItem[];
  onChange?: (item: TItem) => void;
  renderItem?: (item: TItem, index: number) => React.ReactNode;
  validationProps: ValidationProps;
};

export type IValidatedCheckboxGroupProps<TItem = string> = Omit<
  ICheckboxGroupProps<TItem>,
  'checked' | 'onChange'
> & {
  onChange?: ICheckboxGroupProps<TItem>['onChange'];
  validationProps: ValidationProps;
};

export const ValidatedInputLite = (withValidation as (
  component: React.ComponentType<ITextInputProps>
) => React.ComponentType<IValidatedInputProps>)(TextInput);
export const ValidatedInput = withError(ValidatedInputLite);

export const ValidatedRadioGroupLite = withValidation(RadioGroup, CheckedAdapter) as React.ComponentType<IValidatedRadioGroupProps>;
export const ValidatedRadioGroup = withError(ValidatedRadioGroupLite);

export const ValidatedCheckboxGroupLite = withValidation(CheckboxGroup, CheckedAdapter) as React.ComponentType<IValidatedCheckboxGroupProps>;
export const ValidatedCheckboxGroup = withError(ValidatedCheckboxGroupLite);

export { ValidationGroup };
export const ValidationGroupWithErrors = withError(ValidationGroup);
